export class DeleteCloudAccountRequest {
    accountId?: string;
}